// Store functionality
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  award: {},
  participantCompanies: [],
};

// Create a new store
const store = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default store;
